import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Site} from '../../models/site/site';

@Injectable({
  providedIn: 'root'
})
export class SiteService extends AbstractModelService<Site> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/site', Site);
  }
}
